var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25,10.25L7,10.25C5.482,10.25 4.25,11.482 4.25,13C4.25,13 4.25,19 4.25,19C4.25,20.518 5.482,21.75 7,21.75L17,21.75C18.518,21.75 19.75,20.518 19.75,19L19.75,13C19.75,11.482 18.518,10.25 17,10.25L16.75,10.25L16.75,7C16.75,4.394 14.606,2.25 12,2.25C9.394,2.25 7.25,4.394 7.25,7L7.25,10.25ZM18.25,13L18.25,19C18.25,19.69 17.69,20.25 17,20.25C17,20.25 7,20.25 7,20.25C6.31,20.25 5.75,19.69 5.75,19L5.75,13C5.75,12.31 6.31,11.75 7,11.75L17,11.75C17.69,11.75 18.25,12.31 18.25,13ZM12,14.25C11.034,14.25 10.25,15.034 10.25,16C10.25,16.966 11.034,17.75 12,17.75C12.966,17.75 13.75,16.966 13.75,16C13.75,15.034 12.966,14.25 12,14.25ZM15.25,10.25L15.25,7C15.25,5.217 13.783,3.75 12,3.75C10.217,3.75 8.75,5.217 8.75,7L8.75,10.25L15.25,10.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.273f9721.svg";
export { ForwardRef as ReactComponent };